module.exports = __webpack_public_path__ + "static/media/energy_card_blue.e4249015.svg";